<template>
  <div
    id="banbgimg"
    class="top"
    :style="'background-image:url(' + bannerSrc + ');' + tops"
  >
    <!-- <img class="banner" :src="bannerSrc" /> -->
    <index-banner-text
      v-if="isnum == 'index'"
      class="wow bounceInLeft animated"
    />
    <news-banner-text
      v-else-if="isnum == 'news'"
      class="wow bounceInLeft animated"
    />
    <i-psixianghui-text
      v-else-if="isnum == 'ipsx'"
      class="wow bounceInLeft animated"
    />
  </div>
</template>

<script>
import IndexBannerText from "./component/IndexBannerText";
import NewsBannerText from "./component/NewsBannerText";
import IPsixianghuiText from "./component/IPsixianghuiText";

export default {
  name: "Banner",
  components: {
    IndexBannerText,
    NewsBannerText,
    IPsixianghuiText,
  },
  data() {
    return {
      tops: "",
    };
  },
  //监测数据加载完成，初始化动画

  mounted() {
    if (this.isMobile()) {
      // alert("手机端");
      this.tops = this.$cookies.getCookie("tops") || "";
    } else {
      // alert("pc端");
    }
  },
  created() {},
  methods: {
    // 添加判断方法
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  props: ["bannerSrc", "isnum"],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  width: 100%;
  display: block;
  position: relative;
  padding-top: 30%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.banner {
  width: 100%;
  max-height: 600px;
  display: block;
}

@media only screen and (max-width: 600px) {
  .top {
    padding-top: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner/index.vue